import moment from 'moment-timezone';

export const getDateTimeZone = (value) => {
    const utcMoment = moment.utc(value, 'MM-DD-YYYY HH:mm:ss');
    const kolkataMoment = utcMoment.tz('America/New_York');
    const formattedDateTimeString = kolkataMoment.format('MM-DD-YYYY HH:mm');
    return formattedDateTimeString;
};